import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class IdCardsService {
  constructor(protected http: HttpClient) {}

  public getWorkers(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/idcards/getWorkers`
    );
  }

  public print(
    dateInit: Date,
    dateEnd: Date,
    list: string[]
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      responseType: "blob" as 'json',
    };
    return this.http.post(
      `${environment.serverUrl}api/idcards/print`,
      { dateInit, dateEnd, list },
      options
    );
  }
}
